import {
    IStructuredEvent,
    LogglyService,
    LogService,
    LogLevel,
    IUnstructuredEvent,
    ILogglyConfig,
    ModuleConfig,
    getAnonymousId,
} from '@landr/core';
import { CONFIG } from '../config';
import { UserProfile } from '../../types/userProfile';
import { ApplicationVersion } from '../../constants';

export class Log extends LogService {
    loggly: LogglyService;
    _userProfile?: UserProfile | null;

    constructor() {
        super(
            /* eslint-disable no-console */
            {
                log: console.log,
                debug: console.log, // Console.debug not standard
                info: console.log, // Console.info not standard
                warn: console.warn,
                error: console.error,
            },
            /* eslint-enable no-console */
            {
                enabled: CONFIG.LOG_ENABLED === 'true',
                console: {
                    enabled: CONFIG.LOG_CONSOLE_ENABLED === 'true',
                    minLevel: CONFIG.LOG_CONSOLE_MINLEVEL as LogLevel,
                },
                separator: CONFIG.LOG_SEPARATOR,
            },
        );
        this.loggly = this.createLogglyService();
        this.callback = this.logCallback.bind(this);
    }

    set userProfile(userProfile: UserProfile | null) {
        this._userProfile = userProfile;
    }

    protected logCallback(event: IStructuredEvent | IUnstructuredEvent): void {
        const extraParams = {
            url: window && window.top.location.href,
            ...this.formatUserProfileToEventParams(),
        };

        this.loggly.send(event, extraParams);
    }

    private formatUserProfileToEventParams() {
        if (this._userProfile) {
            return {
                userId: this._userProfile.id,
                username: this._userProfile.email || '',
                anonymousId: '',
            };
        } else {
            return {
                userId: '',
                username: '',
                anonymousId: getAnonymousId(),
            };
        }
    }

    private createLogglyService(): LogglyService {
        const config: ILogglyConfig = {
            apiKey: CONFIG.LOG_LOGGLY_API_KEY as string,
            enabled: CONFIG.LOG_LOGGLY_ENABLED === 'true',
            minLevel: CONFIG.LOG_LOGGLY_MINLEVEL as LogLevel,
            tags: CONFIG.LOG_TAGS as string,
            maxBundleSize:
                Number.parseInt(
                    CONFIG.LOG_LOGGLY_MAX_BUNDLE_SIZE as string,
                    10,
                ) || 100,
            forcedModule: {} as ModuleConfig,
        };

        const appVersion = ApplicationVersion || 'Unknown';
        const properties = {
            serviceKey: CONFIG.LOG_SERVICE_KEY as string,
            deploymentKind: CONFIG.LOG_DEPLOYMENT_KIND as string,
            version: appVersion,
            application: CONFIG.LOG_APPLICATION_NAME as string,
            consecutiveOccurrences:
                Number.parseInt(
                    CONFIG.LOG_LOGGLY_CONSECUTIVE_OCCURRENCES as string,
                    10,
                ) || 0,
        };
        return new LogglyService(config, properties, window);
    }
}

export const log = new Log();
